<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-text>
            <v-container fluid grid>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-window v-model="step" show-arrows show-arrows-on-hover>   

                            <v-window-item :value="1">
                                <windowInformacionCertificadoComponent />
                            </v-window-item>

                            <v-window-item :value="2">
                                <windowGastosCobiertosComponent :stepper="step" 
                                                                :listCoberturaActual="_.get(objForm.objInfoSeguroActual,'datosCoberturas',[])"
                                                                :listCoberturaNueva="_.get(objForm.objInfoSeguroRenovacion,'coberturas',[])"
                                                                :obSeguro="_.get(objForm.objInfoSeguroRenovacion,'seguro[0]',{})"
                                                                :parametros="parametros"
                                />
                            </v-window-item>

                            <v-window-item :value="3">
                                <windowBeneficioComplemetarioComponent :stepper="step" 
                                                                       :listBeneficioComplementarioActual="_.get(objForm.objInfoSeguroActual,'datosBeneficiosComplementarios',[])"
                                                                       :listBeneficioComplementarioNueva="_.get(objForm.objInfoSeguroRenovacion,'servicios_incluidos',[])"
                                                                       :parametros="parametros"
                                />
                            </v-window-item>

                            <v-window-item :value="4">
                                <windowAccesoriosComponent             :stepper="step" 
                                                                       :listAccesorioActual="_.get(objForm.objInfoSeguroActual,'datosInclusionAccesorios',[])"
                                                                       :listAccesorioNuevo="_.get(objForm.objInfoSeguroRenovacion,'accesorios',[])"
                                                                       :listCoberturaNueva="_.get(objForm.objInfoSeguroRenovacion,'coberturas',[])"
                                                                       :parametros="parametros"
                                                                       :valorCasco="valorCasco"
                                />
                            </v-window-item>

                            <v-window-item :value="5">
                                <windowEmpezarAhoraComponent           :stepper="step" 
                                                                       :valorCouta="valorCuotaPagar"
                                />
                            </v-window-item>

                            <v-window-item :value="6">
                                <windowDatosFacturaComponent           :stepper="step" 
                                                                       :listGeneral="listGeneral"
                                                                       :objFormFactura="objForm.objFormFactura"
                                                                       :parametros="parametros"
                                                                       :textoTerminoCondicionVenta="_.get(objForm.objInfoSeguroRenovacion,['seguro','0','texto_termino_condicion_venta'],'')"
                                />
                            </v-window-item>

                        </v-window>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-btn large color="primary" absolute bottom right fixed width="15%" height="40px" rounded :block="$root.isTouch" v-show="step > 1 && step < 6">
            <p class="text-capitalize text-center mt-3" v-html="`Pagar $${valorCuotaPagar}/mes`"></p>
        </v-btn>
    </v-card>
</template>

<script>
    export default {
        name: 'RenovacionView',
        components:{
            windowInformacionCertificadoComponent: () => import('@/components/ajustePoliza/renovacion/vehiculo/windowInformacionCertificadoComponent.vue'),
            windowGastosCobiertosComponent: () => import('@/components/ajustePoliza/renovacion/vehiculo/windowGastosCobiertosComponent.vue'),
            windowBeneficioComplemetarioComponent: () => import('@/components/ajustePoliza/renovacion/vehiculo/windowBeneficioComplemetarioComponent.vue'),
            windowAccesoriosComponent: () => import('@/components/ajustePoliza/renovacion/vehiculo/windowAccesoriosComponent.vue'),
            windowEmpezarAhoraComponent: () => import('@/components/ajustePoliza/renovacion/vehiculo/windowEmpezarAhoraComponent.vue'),
            windowDatosFacturaComponent: () => import('@/components/ajustePoliza/renovacion/vehiculo/windowDatosFacturaComponent.vue')
        },
        data: () => ({
            step: 1,
            idCliente:null,
            listGeneral: {
                detalle: []
            },
            parametros: {},
            objSend:{
                obImpuesto:{},
                obPrima: [],
                datosFactura:{},
                obVehiculo:{},
                listAccesorios:[],
                listCoberturas: [],
                listServiciosIncluidos:[]
            },
            objForm: {
                objInfoSeguroActual: {},
                objInfoSeguroRenovacion: {},
                objFormFactura: {}
            }
        }),
        computed:{
            valorCasco(){
                var l = _.cloneDeep(_.get(this.objForm.objInfoSeguroRenovacion,'coberturas',[]));
                var o = _.find(l,{'id_cobertura':this.parametros.id_cobertura_todo_riesgo_wizard});

                return _.get(o,'valor_cobertura',0);
            },
            valorCuotaPagar(){
                var p = parseFloat(_.get(this.objForm.objInfoSeguroRenovacion,['prima','0','prima_neta'],0));
                var mesesDiferido = parseInt(_.get(this.objForm.objInfoSeguroRenovacion,['prima','0','meses_diferido_prima'],1));
                var t = _.round((p/mesesDiferido),2);
                return parseFloat(t).toFixed(2);
            }
        },
        methods:{
            next(band = true){
                if(band){
                    ++this.step;
                }else{
                    this.step = 4;
                }
            },
            setData(keyNameObject,data){
                var v = data;
                if(!_.isArray(v))
                    v = _.merge({},_.get(this,keyNameObject,{}),data);
                
                _.set(this,keyNameObject,v);
                this.$set(this,'objForm',this.objForm);
                this.$set(this,'listGeneral',this.listGeneral);
            },
            preparateData(){
                var keys = {
                    cobertura: ['id_cobertura','valor_cobertura','porc_tasa','valor_tasa'],
                    servicios_incluidos: ['id_beneficio_comp','id_aseguradora','id_seguro','id_tipo_calculo','valor_costo','valor_costo_diferido','porc_costo','check'],
                    accesorios: ['icono','icono_app','add','index'],
                    factura: ['idTipoPersona','idTipoDocumento','idCanton','numeroDocumento','nombreCliente','telefono','direccion','email','idCliente']
                };

                var objeto = _.cloneDeep(this.objForm.objInfoSeguroRenovacion);
                var listCoberturas = _.map(_.get(objeto,['coberturas'],[]), _.partialRight(_.pick, keys.cobertura));
                var listServiciosIncluidos = _.map(_.filter(_.get(objeto,'servicios_incluidos',[]),{active:true}), _.partialRight(_.pick, keys.servicios_incluidos));
                var listAccesorios = _.map(_.filter(_.get(objeto,'accesorios',[]),{'add':true}),_.partialRight(_.omit, keys.accesorios)); 
                var datosFactura   = _.pick(this.objForm.objFormFactura,keys.factura);
                var obImpuesto     = {'impuesto':_.get(objeto,'impuestos',[]) ,'otro':_.get(objeto,'otros',[])}; 
                var obPrima        = [
                                        {"tipo_prima": "prima_bruta", "prima_bruta": _.get(objeto,['prima','0','prima_bruta'])},
                                        {"tipo_prima": "prima_neta", "prima_neta": _.get(objeto,['prima','0','prima_neta'])},
                                        {"tipo_prima": "tasa_recarga", "tasa_recarga": _.get(objeto,['prima','0','tasa_recarga'])},
                                    ];

                this.objSend = {
                    listCoberturas,
                    listServiciosIncluidos,
                    listAccesorios,
                    datosFactura,
                    obImpuesto,
                    obPrima
                }
            },
            recalcularPrima(recalcularBeneficiosComplementarios=true) {
                
                this.preparateData();
                var idCobCasco   = this.parametros.id_cobertura_todo_riesgo_wizard;
                var obCasco = _.find(this.objSend.listCoberturas,{'id_cobertura':idCobCasco});

                var objeto = {
                    recalcularBeneficiosComplementarios: recalcularBeneficiosComplementarios,
                    id_producto               : _.get(this.objForm.objInfoSeguroRenovacion,['seguro','0','id_producto'], null),
                    valorCoberturaCasco       : _.get(obCasco, 'valor_cobertura', 0),
                    data_coberturas           : this.objSend.listCoberturas,
                    data_servicios_incluidos  : this.objSend.listServiciosIncluidos,
                    data_impuestos            : _.get(this.objSend.obImpuesto, 'impuesto', []),
                    data_otros                : _.get(this.objSend.obImpuesto, 'otro', [])
                };

                return axios.post(`${BASE_URI}wizard/recalcular-prima`, objeto)
                    .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion);

                            // Prima
                            this.$set(this.objForm.objInfoSeguroRenovacion,'prima',_.get(r.data.data, 'prima', []));

                            // Servicios Incluidos
                            var l = _.cloneDeep(this.objForm.objInfoSeguroRenovacion.servicios_incluidos);
                            var listServiciosIncluidos = _.cloneDeep(_.get(r.data.data, 'servicios_incluidos', []));
                            var keysSerString = [
                                            'id_producto','id_beneficio_comp','id_aseguradora','id_seguro','beneficio_comp',
                                            'definicion_corta','definicion_tecnica_cis','id_tipo_calculo','base64'
                                          ];

                            var keysSerInt = ['valor_costo','valor_costo_diferido','porc_costo'];

                            l = _.map(l,(v)=>{
                                    var o = _.find(listServiciosIncluidos,{ 'id_beneficio_comp': v.id_beneficio_comp });
                                    if(_.isUndefined(v.active) || _.isNull(v.active))
                                        v.active = !_.isUndefined(o) ? true : false;

                                    _.forEach((keysSerInt),(vv)=>{ _.set(v,vv,parseFloat(_.get(o,vv,_.get(v,vv,0)))); });
                                    _.forEach((keysSerString),(vv)=>{ _.set(v,vv,_.get(o,vv,_.get(v,vv,null))); });
                                    
                                    if(_.size(_.get(o,'base64','')) > 0){
                                        var s = _.split(o.base64,',');
                                        v.base64 = _.includes(o.base64,'data:image/svg') ? `data:image/svg+xml;base64,${s[1]}` : o.base64;
                                    }

                                    if(!_.isUndefined(o))
                                        v.mensaje = _.toNumber(_.get(o,'valor_costo_diferido',0)) > 0 ? `$${parseFloat(_.get(o,'valor_costo_diferido',0)).toFixed(2)}/MES` : 'GRATIS';
                                        
                                return v;
                            });

                            this.$set(this.objForm.objInfoSeguroRenovacion,'servicios_incluidos',l);

                            var objImpuesto = {
                                opcion: "LISTAR_X_SEGURO_VEHICULO",
                                id_seguro: _.get(this.objForm.objInfoSeguroRenovacion, ['seguro', '0', 'id_seguro'], null),
                                id_estado: this.parametros.id_estado_default,
                                prima_bruta: _.get(this.objForm.objInfoSeguroRenovacion, ['prima', '0', 'prima_bruta'], 0)
                            };

                            return axios.post(`${BASE_URI}administrador/impuesto/listar`, objImpuesto);
                    })
                    .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion);
                            this.$set(this.objForm.objInfoSeguroRenovacion,'impuestos',r.data.data);

                            var objDerecho = {
                                opcion: "LISTAR_X_SEGURO_VEHICULO",
                                id_seguro: _.get(this.objForm.objInfoSeguroRenovacion, ['seguro', '0', 'id_seguro'], null),
                                id_estado: this.parametros.id_estado_default,
                                prima_bruta: _.get(this.objForm.objInfoSeguroRenovacion,['prima','0','prima_bruta'],0)
                            };

                            return axios.post(`${BASE_URI}administrador/parametro-derecho-emision/listar`, objDerecho);
                    })
                    .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion);
                            this.$set(this.objForm.objInfoSeguroRenovacion,'otros',r.data.data);
                            this.preparateData();
                            return true;
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                        return false;
                    });
            },
            onBotonPago() {
                // Validamos que los datos esten correctos
                return new Promise((resolve,reject)=>{
                    this.preparateData();
                    return resolve(true);
                })
                .then((r)=>{
                    if(!r) throw 'error';
                        this.insertarRenovacion();
                })
                .catch((e)=>{
                    mensajesAlerta(e,'E');
                });
            },
            insertarRenovacion(){
                try {
                    var error = 'E';
                    if(this.btn) throw 'Ya se encuentra ejecutandose la operación.'
                    var idCasco = _.get(this.objForm.objInfoSeguroRenovacion,'id_cobertura_todo_riesgo_wizard',0);
                    var objVeh = _.find(this.objSend.listCoberturas,(v) => { return parseInt(v.id_cobertura) == parseInt(idCasco); });
                    var objeto = _.merge({},
                        {
                            idCertificado   : _.get(this.objForm.objInfoSeguroActual,['dataCertificado','idCertificado'],null),
                            idSeguro        : _.get(this.objForm.objInfoSeguroActual,['dataCertificado','idSeguro'],null),
                            idPoliza        : _.get(this.objForm.objInfoSeguroActual,['dataCertificado','idPoliza'],null),
                            idPolizaNueva   : _.get(this.objForm.objInfoSeguroRenovacion,['seguro','0','id_poliza'],null),
                            idPlanProducto  : _.get(this.objForm.objInfoSeguroRenovacion,['seguro','0','id_plan_producto'],null),
                            idProducto      : _.get(this.objForm.objInfoSeguroRenovacion,['seguro','0','id_producto'],null),
                            obVehiculo      : { valorVehiculo: _.get(objVeh,'valor_cobertura',0), valorRecomendado: _.get(this.objForm.objInfoSeguroRenovacion,['seguro','0','valor_recomendado'],0) }
                        },
                        this.objSend
                    );
    
                    this.btn = true;
                    axios.post(`${BASE_URI}administrador/renovacion/vehiculo/insertar`,objeto)
                        .then((r) => {
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0){ error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                mensajeAlertaTiempo('Renovación exitosa, por favor revise su bandeja de entrada de su correo, donde recibira los documentos de su seguro.','S');
                                setTimeout(() => {
                                    window.location.reload();
                                }, 4000);
                        })
                        .catch((e) =>{
                            this.btn = false;
                            mensajesAlerta(e,error);
                        });
                } catch (error) {
                    mensajesAlerta(e,error);
                }
            }
        },
        provide(){
            return{
                edit      : this.renovacion,
                next      : this.next,
                updateData: this.setData,
                recalcularPrima: this.recalcularPrima,
                onBotonPago: this.onBotonPago
            }
        }
    }
</script>

<style>
    .titleSection {
        color: #FF4132;
        font-style: italic;
        font-weight: 700;
        font-size: 1.80rem;
    }

    .contenido {
        font-size: 0.85rem;
        color: #808080;
        font-weight: 300;
        text-transform: none;
    }

    .v-window__next{
        display: none;
    }

    .btnNext:hover{
        color: #FF4132;
    }
</style>